import React, { useEffect } from 'react';
import { CheckCircleIcon, ClipboardCheckIcon, MessageCircleIcon, CarIcon, StarIcon, PhoneIcon } from 'lucide-react';
import FacebookPixel from '../components/tracking/FacebookPixel';
import { track } from '../components/tracking/metaPixel';
import { getWhatsAppLink } from '../utils/whatsappLink';
const ThankYou = () => {
  const whatsappLink = getWhatsAppLink('Hola Pedro, acabo de enviar mi solicitud y quiero respuesta urgente.');
  useEffect(() => {
    // Registrar el evento de conversión Lead en la página de agradecimiento
    track('Lead', {
      content_name: 'Formulario Auto',
      status: 'complete'
    });
    // También registrar evento Purchase para conversiones de alto valor
    if (window.fbq) {
      window.fbq('track', 'Purchase', {
        value: 1.0,
        currency: 'USD',
        content_name: 'Lead Completo',
        content_type: 'product',
        content_ids: ['auto_lead']
      });
      console.log('Evento Purchase disparado correctamente');
    } else {
      console.error('Error: fbq no está disponible para el evento Purchase');
    }
  }, []);
  const steps = [{
    icon: <ClipboardCheckIcon className="w-8 h-8 text-primary" data-id="element-548" data-mp="238w36gh4yqep" />,
    title: '1. Revisión',
    description: 'Pedro revisa tu solicitud personalmente.'
  }, {
    icon: <MessageCircleIcon className="w-8 h-8 text-primary" data-id="element-549" data-mp="1u7g24zc7o0n5" />,
    title: '2. Contacto',
    description: 'Te contacta por WhatsApp o llamada en minutos.'
  }, {
    icon: <CarIcon className="w-8 h-8 text-primary" data-id="element-550" data-mp="2lx10b53afd4j" />,
    title: '3. Opciones',
    description: 'Te presenta las mejores opciones para ti.'
  }];
  return <div className="font-sans text-dark bg-gray-50 min-h-screen w-full flex flex-col" data-id="element-551" data-mp="2h47x4lngwcuk">
      <FacebookPixel data-id="element-552" data-mp="2d2wej030grvv" />

      {/* Main Content */}
      <main className="flex-grow flex items-center justify-center p-4" data-id="element-553" data-mp="39n52d80tv4tf">
        <div className="w-full max-w-3xl bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100" data-id="element-554" data-mp="34wezc1fvje1w">
          {/* Success Header */}
          <div className="bg-primary p-8 md:p-12 text-center relative overflow-hidden" data-id="element-555" data-mp="12zxt6azu0tok">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] pointer-events-none" data-id="element-556" data-mp="17zskgfnirla5"></div>

            <div className="relative z-10 flex flex-col items-center" data-id="element-557" data-mp="y6uu5ncacs0z">
              <div className="bg-white rounded-full p-4 mb-6 shadow-lg animate-bounce-slow" data-id="element-558" data-mp="k8ep00u2n9ky">
                <CheckCircleIcon className="w-16 h-16 text-[#25D366]" data-id="element-559" data-mp="p780jnpssqih" />
              </div>
              <h1 className="font-heading font-bold text-3xl md:text-4xl text-white mb-4" data-id="element-560" data-mp="a9ywbtfebs9c">
                ¡Gracias, tu solicitud fue recibida!
              </h1>
              <p className="text-gray-300 text-lg max-w-xl mx-auto" data-id="element-561" data-mp="f9k6l000nn1d">
                Pedro te contactará personalmente en los próximos minutos por
                WhatsApp o llamada.
              </p>
            </div>
          </div>

          {/* Next Steps Section */}
          <div className="p-8 md:p-12" data-id="element-562" data-mp="3u4c9hq755v2y">
            <h2 className="text-center font-heading font-semibold text-xl text-primary mb-8 uppercase tracking-wide" data-id="element-563" data-mp="3u5dm3z3t2pms">
              ¿Qué pasa ahora?
            </h2>

            <div className="grid md:grid-cols-3 gap-8 mb-12 relative" data-id="element-564" data-mp="7qknkvggvxij">
              {/* Connecting Line (Desktop) */}
              <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-gray-100 -z-10" data-id="element-565" data-mp="2x84t1ygykxp"></div>

              {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center bg-white" data-id="element-566" data-mp="cp5e235x32ts" data-mpi={index}>
                  <div className="bg-gray-50 p-4 rounded-full border border-gray-100 mb-4 shadow-sm" data-id="element-567" data-mp="qnlx8tkyulst">
                    {step.icon}
                  </div>
                  <h3 className="font-bold text-lg text-primary mb-2" data-id="element-568" data-mp="2seynqdm6sr5c">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-569" data-mp="2nhyqms7beyqd">{step.description}</p>
                </div>)}
            </div>

            {/* Trust Reinforcement */}
            <div className="bg-gray-50 rounded-xl p-6 border border-gray-100 text-center mb-8" data-id="element-570" data-mp="2tw4e2ore6a3b">
              <div className="flex justify-center gap-1 mb-3" data-id="element-571" data-mp="2yvgwmxb8cv03">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-[#FFD700] fill-[#FFD700]" data-id="element-572" data-mp="33u1zl4hv9ss8" data-mpi={i} />)}
              </div>
              <p className="font-medium text-primary mb-1" data-id="element-573" data-mp="2b5wfmjyn07tg">
                "En 2 horas ya estaba manejando. Pedro me resolvió todo."
              </p>
              <p className="text-sm text-gray-500" data-id="element-574" data-mp="2g3fsbffoscja">
                — Jorge, Hialeah (Uno de las 500+ familias ayudadas)
              </p>
            </div>

            {/* Secondary CTA */}
            <div className="text-center border-t border-gray-100 pt-8" data-id="element-575" data-mp="1nglayre61ta1">
              <p className="text-gray-500 text-sm mb-3" data-id="element-576" data-mp="1sewmd6k40bud">
                ¿Necesitas respuesta urgente?
              </p>
              <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-primary font-semibold hover:text-secondary transition-colors" data-id="element-577" data-mp="9ka9uytzo2mj">
                <MessageCircleIcon className="w-4 h-4" data-id="element-578" data-mp="3rr85cddzwyyf" />
                Escribir directo al WhatsApp
              </a>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-6 text-center text-gray-400 text-sm" data-id="element-579" data-mp="3i0dcgq68v140">
        <div className="container mx-auto" data-id="element-580" data-mp="3dz1n8lra8hwc">
          <p data-id="element-581" data-mp="3dztj7xoskhn5">
            © {new Date().getFullYear()} Pedro de la Cruz — Fleet Manager,
            Miami
          </p>
        </div>
      </footer>
    </div>;
};
export default ThankYou;